import Config from '../config';
import $ from '../../utils/net';
import { msg } from "@lingui/core/macro";
import { CasinoApi, GameEntry, GamesBrand } from '../casino-feed.js';
import { CasinoServiceData, CasinoServiceFilters } from './legacy-api.js';
import { makeReactive } from '../../utils/reactive-store';

const state: CasinoServiceData & CasinoServiceFilters = makeReactive({
    providers: {},
    'providers-timestamp': 0,
    filter: {
        provider: false,
        category: false
    },
});

export class CasinoService implements CasinoApi {
    eventListeners: (() => any)[] = [];

    async setup(): Promise<void> {
        try {
            // tolti dati legacy
            window.safeLocalStorage.removeItem('full-providers-db-timestamp');
            window.safeLocalStorage.removeItem('full-providers-db');
        } catch (e) {
            // no
        }
        const brands = await this.getGamesDB();
        state.providers = brands;
        state['providers-timestamp'] = Date.now();
        this.eventListeners.forEach(cb => cb());
    }
    applyCategoryFilter(category: false | string, provider: false | string = false) {
        state.filter.category = category;
        state.filter.provider = provider;
        this.eventListeners.forEach(cb => cb());
    }
    getSelectedCategoryId() {
        return state.filter.category;
    }
    getSelectedCategoryName() {
        return !!state.filter.category && !!state.providers[state.filter.category] ?
            state.providers[state.filter.category].name : window.Translation(msg`Tutte le Slots`);
    }
    getSelectedCategoryLogo() {
        console.info(state.providers);
        return !!state.filter.category && !!state.providers[state.filter.category] ?
            state.providers[state.filter.category].logo : null;
    }
    clearCategoryFilter() {
        this.applyCategoryFilter(false);
    }
    fetchCmsPages(): Promise<CmsResponse> {
        return new Promise((res, rej) => $.getJSON(Config.softionAPI + "/ccg/cmsPages?json", (err: any, data: CmsResponse) => {
            return !!err ? rej(err) : res(data);
        }))
    }
    fetchGames(): Promise<GamesResponse> {
        return new Promise((res, rej) => $.getJSON(Config.softionAPI + "/ccg/gamesClean?json", (err: any, data: GamesResponse) => {
            return !!err ? rej(err) : res(data);
        }))
    }
    async getGamesDB(): Promise<CasinoServiceData["providers"]> {
        const cacheContents = safe(() => JSON.parse(window.safeLocalStorage.getItem('new-providers-db')), false);
        const lastFetchTime = parseInt(window.safeLocalStorage.getItem('new-providers-db-timestamp') || '0');
        if (Date.now() - lastFetchTime <= 5 * 60e3 && !!cacheContents) {
            return cacheContents;
        }
        const gamesResponse = await this.fetchGames();
        const brands: CasinoServiceData["providers"] = gamesResponse.data.providers.map(({ provider, games }): GamesBrand => {
            return {
                provider: provider.aggregator_id,
                id: provider.brand_id,
                logo: '',
                name: provider.name.split('/').slice(-1)[0],
                sub: games.map(game => ({
                    id: game.game_id,
                    category: game.brand_id,
                    provider: game.aggregator_id,
                    logo: game.logo_url,
                    name: game.name,
                    sort: game.order,
                    tags: [game.mobile && 'mobile', game.desktop && 'desktop'].filter(t => !!t)
                })).sort((a, b) => (a.sort || 9999) - (b.sort || 9999))
            }
        }).reduce((c, brand) => {
            c[brand.provider + '/' + brand.id] = brand;
            return c;
        }, {});

        try {
            window.safeLocalStorage.setItem('new-providers-db', JSON.stringify(brands))
            window.safeLocalStorage.setItem('new-providers-db-timestamp', "" + Date.now())
        } catch (e) { }

        return brands;
    }

    providersList() {
        return state.providers;
    }

    getPlayUrl(provider: string, brand: string, game: string) {
        return Config.softionAPI + '/ccg/play/' + [provider, brand, game].join('/');
    }
    flattenSlotList = (): GameEntry[] => {
        return Object.values(state.providers).flatMap(provider => provider.sub);
    }

    listenChanges = (cb: { (): void; }) => {
        return this.eventListeners.push(cb);
    }
    unlistenChanges = (cb: { (): void; }) => {
        return this.eventListeners = this.eventListeners.filter(c => c != cb);
    }
    notifyChanges = () => this.eventListeners.forEach(cb => cb());
}

export type CmsResponse = {
    data: {
        pages: CmsPage[]
    }
}

export type CmsPage = {
    code: string,
    name: string,
    rows: PageWidget[]
}

export type PageWidget = {
    type: "provider"|"category"|"favourites"|"recently-played",
    code: string,
    order: number,
    data: {
        name: string,
        cols: number,
        rows: number,
        icon?: string,
        provider?: string,
        category?: string,
        games: GameRef[]
    }
}

export type GameRef = {
    aggregator_id: string,
    brand_id: string,
    game_id: string,
}

type GamesResponse = {
    data: {
        providers: ApiProviderEntry[]
    }
}

type ApiProviderEntry = {
    provider: ApiProviderData,
    games: ApiGameEntry[],
}

type ApiProviderData = {
    aggregator_id: string,
    brand_id: string,
    name: string,
}

type ApiGameEntry = {
    aggregator_id: string,
    brand_id: string,
    game_id: string,
    name: string,
    logo_url: string,
    order: number,
    mobile: boolean,
    desktop: boolean
}

function safe<T>(fn: (() => T), err: null | T): null | T {
    try {
        return fn();
    } catch (e) {
        return err;
    }
}


function indexBy<T>(tag: keyof T) {
    return (c: { [key: string]: T; }, data: T) => ({ ...c, [String(data[tag])]: data });
}